import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function NovedadesFaltaRecepcionDeRemito() {
  return (
    <ClipperPlaceholder title="Falta Recepción de Remito" category="Novedades" />
  );
}
